function PanelDisplayImage(props) {
    return (
     <div className="step">
         <img src={props.imagesrc} className="image-center"/>
     </div>
    );
  }
  
 export default PanelDisplayImage;